import React from 'react'
import { useDevice } from 'device'
import { useAb } from 'hooks'
import { constants } from 'helpers'
import { Helmet } from 'react-helmet-async'

import { Video } from 'components/dataDisplay'

import desktopVideoB from './images/desktop-b.mp4'
import desktopVideoC from './images/desktop-c.mp4'
import mobileVideoB from './images/mobile-b.mp4'
import mobileVideoC from './images/mobile-c.mp4'

import desktopPreviewB from './images/desktop-preview-b.jpg'
import desktopPreviewC from './images/desktop-preview-c.jpg'
import mobilePreviewB from './images/mobile-preview-b.jpg'
import mobilePreviewC from './images/mobile-preview-c.jpg'


const mobileVideoProps = {
  'b': {
    url: mobileVideoB,
    preview: mobilePreviewB,
    aspect: 1,
  },
  'c': {
    url: mobileVideoC,
    preview: mobilePreviewC,
    aspect: 9 / 16,
  },
}

const desktopVideoProps = {
  'b': {
    url: desktopVideoB,
    preview: desktopPreviewB,
    aspect: 4 / 5,
  },
  'c': {
    url: desktopVideoC,
    preview: desktopPreviewC,
    aspect: 16 / 9,
  },
}

const mobileWrapperStyles = {
  'b': {
    bottom: 0,
    left: 0,
    width: '100%',
    height: '55%',
  },
  'c': {
    top: 0,
    left: 0,
    width: '100%',
  },
}

const desktopWrapperStyles = {
  'b': {
    top: 0,
    right: 0,
    width: '50%',
  },
  'c': {
    top: 0,
    left: 0,
    width: '100%',
  },
}

const VideoHero: React.FunctionComponent = () => {
  const { isMobile } = useDevice()
  const testVersion = useAb(constants.abTests.homeVideoHero)

  if (testVersion === 'a') {
    return null
  }

  const videoTestProps = isMobile ? mobileVideoProps : desktopVideoProps
  const videoProps = videoTestProps[testVersion]

  const wrapperTestStyles = isMobile ? mobileWrapperStyles : desktopWrapperStyles
  const wrapperStyles = wrapperTestStyles[testVersion]

  const overlayBackground = isMobile ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 0, 0, 0.2)'

  return (
    <div className="absolute w-full h-full" style={wrapperStyles}>
      <Helmet>
        <link rel="preload" href={videoProps.preview} as="image" />
      </Helmet>
      <Video
        className="w-full h-full"
        videoClassName="bg-gold-30"
        type="mp4"
        autoplay
        muted
        playsinline
        loop
        {...videoProps}
      />
      {
        testVersion === 'c' && (
          <div className="absolute top-0 left-0 w-full h-full" style={{ background: overlayBackground }} />
        )
      }
    </div>
  )
}


export default VideoHero
